import { withResourceEditProvider } from 'js/components/ResourceEditProvider/withResourceEditProvider';
import { find } from 'lodash';
import { useResourceDetailHandler } from 'new/components/ResourceDetailHandler/context';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import {
  activateDataset,
  copyDataset,
  copyDatasetToClipboard,
  deleteDataset,
  pauseDataset,
  refreshPipeline,
  setPipelineAction,
  splitterReset,
} from '../../../actions';
import {
  ACTIVATE_DATA_SET,
  COPY_DATA_SET,
  DELETE_DATA_SET,
  PAUSE_DATA_SET,
} from '../../../constants/processTypes';
import { isDetectedDataset } from '../../../lib/ResourceUtils';
import DataSetDetailActions from './DataSetDetailActions';

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { sources, flowNodes, dataSets },
    dataSets: { clipboardDatasetId },
    processes: { all: processes },
  } = state;
  const { data } = ownProps;
  const { id } = data;
  const isDetected = isDetectedDataset(data);
  // Pause/activate from the Nexset card always operate on the Nexset itself,
  // never on the upstream source — track only the dataset-scoped processes.
  const isPausing = !!find(processes, { type: PAUSE_DATA_SET, id });
  const isActivating = !!find(processes, { type: ACTIVATE_DATA_SET, id });
  const isCopying = !!find(processes, { type: COPY_DATA_SET, id });
  const isDeleting = !!find(processes, { type: DELETE_DATA_SET, id });

  const flow = flowNodes[data.origin_node_id];
  const source = sources[flow?.data_source_id || data.data_source];
  const parentDataSet = dataSets[data.parent_data_set_id];

  return {
    isDetected,
    dataSetChildren: flowNodes[data.flow_node_id]?.children || data.data_sinks,
    source,
    flow,
    parentDataSet,
    clipboardDatasetId,
    isPausing,
    isActivating,
    isCopying,
    isDeleting,
    nodeType: data.node_type,
  };
};

function DataSetDetailActionsWithContext(props) {
  const { openDetailDrawerInPortal } = useResourceDetailHandler();
  return <DataSetDetailActions {...props} openDetailDrawerInPortal={openDetailDrawerInPortal} />;
}

export default compose(
  connect(mapStateToProps, {
    activateDataset,
    pauseDataset,
    copyDataset,
    deleteDataset,
    refreshPipeline,
    splitterReset,
    copyDatasetToClipboard,
    setPipelineAction,
  }),
  withResourceEditProvider,
  withRouter,
)(DataSetDetailActionsWithContext);
